import { Button, ButtonBase, Input, MuiThemeProvider, Select } from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment';
import AudienceSlider from '../selectionMenu/components/AudienceSlider'
import React from 'react'
import { createMuiTheme } from '@material-ui/core'
import { mainTheme } from '../../../../theme/ddTheme'
import { fetchChannels } from '../../util/dataFetches/fetchChannels'
import CryptoJS from 'crypto-js'
import { saveData, getData, deleteData } from '../../util/caching/indexdbManager';
import { fetchCounts } from '../../util/dataFetches/fetchCounts';
import { sumFieldJsonArray } from '../../util/dataAgg/sumFieldJsonArray';
import AbortController from 'abort-controller';
import { checkStartForm } from '../../util/validation/checkStartForm';
import { evaluateAudienceButtonDisabled } from '../../util/validation/evaluateAudinceButtonDisabled';
import { filterShortFallLocations } from '../../util/dataAgg/filterShortFallLocations';
import { LoadingBanner } from '../selectionMenu/components/loadingBanner';

const defaultTheme = createMuiTheme(mainTheme)

export class StartForm extends React.Component {
  constructor(props) {
    super(props)

    const clientName = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("conceptName"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )

    this.state = {
      isShown: true, // Used to detern if the form is displayed
      audienceRatio: 0.5,
      isGiveMeTheBest: false,
      thresholdSelection: "noThreshold",
      isWholeOrLocation: true,
      targetSpend: null,
      targetQuanity: null,
      minProspects: null,
      channels: [],
      activeChannel: null,

      // Client Config
      clientName: clientName,
      id: props.id,

      // Query Management
      isFetchingAudiences: false,

      // Error Warning
      formErrorMessage: ""
    }
    this.controller = new AbortController()
  }

  async handleInitalStateLoad() {
    // Loading cached channels
    let abChannels = await getData("auienceBuilder", 'abForm', 'abChannels')
    // Check for the same client && TTL
    if (abChannels !== null && abChannels !== '' && abChannels !== undefined && abChannels.clientName === this.state.clientName && abChannels.ttl > Date.now()) {
      this.setState(e => {
        e.channels = abChannels.channels
        return e
      })
    }
    else {
      // Fetch Channels
      let data = await fetchChannels()

      // Filter Based on Current Chanels
      let clientChannelArray = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("channels"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8))
      data = data.filter((a) => clientChannelArray.includes(a.id))

      // Update the Front End
      this.setState(e => {
        e.channels = data.sort((a, b) => a.program.localeCompare(b.program))
        e.activeChannel = data[0]

        // Update the Audience Ratio on the Inital Load
        if(data[0].combined.hasProspects && data[0].combined.hasCustomers) {
          e.audienceRatio = 0.5
        }
        else if(data[0].combined.hasProspects) {
          e.audienceRatio = 0
        }
        else {
          e.audienceRatio = 1
        }

        // Set Cookie
        return e
      })

      await saveData("auienceBuilder", 'abForm', 'abChannels', {
        "channels": data.sort((a, b) => a.program.localeCompare(b.program)),
        "clientName": this.state.clientName,
        "ttl": Date.now() + 21600000 // 6 Hours
      })
      // Save Form Data
      await saveData("auienceBuilder", 'abForm', 'formData', this.state)
    }
  }

  componentDidMount() {
    const asyncFunc = async () => {
      // Fetch Data from INDEX DB
      let abFormData = await getData("auienceBuilder", 'abForm', 'formData')

      // Is Valid Form
      if (abFormData !== null && abFormData !== '' && abFormData !== undefined) {
        // Remove Record From Audience Builder
        await deleteData("auienceBuilder", 'abForm', 'formData')

        // Parse data and Update State
        this.setState(e => { return { ...e, ...abFormData } })

        // Parse Data Back
        if (this.props.hasOwnProperty('dataCallback')) {
          this.props.dataCallback({ ...this.state, ...abFormData })
        }
      }
      await this.handleInitalStateLoad()
    }
    asyncFunc()
  }

  handleSubmit() {
    let updatedState = {}
    // Handle Fetching
    if (!this.state.isFetchingAudiences) {
      // Check for valid submission
      let error = checkStartForm(this.state)
      this.setState({ formErrorMessage: error })
      if (error) {
        return
      }

      const asyncFunc = async () => {
        // Query Audience Using Data
        this.setState(e => {
          e.isFetchingAudiences = true
          return e
        })

        let audConfig = {
          'includeList': [],
          'excludeList': [],
          'audienceSegments': []
        }
        if (this.props.hasOwnProperty('audienceConfig')) {
          audConfig = this.props.audienceConfig
        }

        // Update Backend Options
        let backendOptions = {
          // Filter Selection
          ...audConfig,

          // New Selections
          activeChannel: this.state.activeChannel,
          thresholdSelection: this.state.thresholdSelection,
          isWholeOrLocation: this.state.isWholeOrLocation,
          targetSpend: this.state.targetSpend,
          targetQuanity: this.state.targetQuanity,
          audienceRatio: this.state.audienceRatio,
          isGiveMeTheBest: this.state.isGiveMeTheBest,
          minProspects: this.state.minProspects,

          // Client Params
          clientName: this.state.clientName
        }

        const removeUndefinedFields = (obj) => {
          return Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => value !== undefined)
          );
        };

        // Query API
        let responseData = await fetchCounts(removeUndefinedFields(backendOptions), this.controller.signal)
        // Update Front End
        if (responseData !== null) {
          // Marketable
          let sumCustomers = sumFieldJsonArray("Selected Marketable Customers", responseData.location_data)
          let sumProspects = sumFieldJsonArray("Selected Marketable Prospects", responseData.location_data)
          let sumCustomerAccounts = sumFieldJsonArray("Selected Marketable Customer Accounts", responseData.location_data)
          let marketableCustomers = sumCustomers + sumProspects

          // Short Fall Notification
          let shortFallLocations = filterShortFallLocations(responseData.location_data)

          // Control
          let sumCustomersControl = sumFieldJsonArray("Selected Control Customers", responseData.location_data)
          let sumProspectsControl = sumFieldJsonArray("Selected Control Prospects", responseData.location_data)
          let sumControlAccounts = sumFieldJsonArray("Selected Control Customer Accounts", responseData.location_data)
          let sumControl = sumCustomersControl + sumProspectsControl

          updatedState = {
            locationData: responseData.location_data,
            prospectFilterRule: responseData.prospectFilterRule,
            customerFilterRule: responseData.customerFilterRule,
            shortFallLocations: shortFallLocations,
            audienceBreakdown: {
              marketable: {
                total: marketableCustomers,
                customer_accounts: sumCustomerAccounts,
                prospects: sumProspects,
                customers: sumCustomers
              },
              control: {
                total: sumControl,
                control_accounts: sumControlAccounts,
                prospects: sumProspectsControl,
                customers: sumCustomersControl
              },
              // email: {
              //   total: 0,
              //   test:0
              // }
            },
            // ALSO SAVE COUNTS FOR LEGACY PURPOSES
            counts: [
              {
                "counts": [
                  {
                    "customers": {
                      "control": sumControl,
                      "marketable": sumCustomers,
                      "total": sumCustomers
                    },
                    "prospects": {
                      "control": sumProspectsControl,
                      "marketable": sumProspects,
                      "total": sumProspects
                    },
                    "total_customers": {
                      "total": marketableCustomers
                    }
                  }
                ],
                "refreshedAt": Date.now()
              }
            ]
          }

          this.setState(updatedState)
        }
        // Do not update state if nothing loads
        else {
          this.setState(e => {
            e.isFetchingAudiences = false
            return e
          })
          return
        }
        // Reset Pull Flag
        this.setState(e => {
          e.isFetchingAudiences = false
          return e
        })

        // Parse Data Back
        if (this.props.hasOwnProperty('dataCallback')) {
          this.props.dataCallback(this.state)
        }

        // Save New Data & Route to Audience Builder
        await saveData("auienceBuilder", 'abForm', 'formData', { ...this.state, ...backendOptions, ...updatedState })
        await saveData("auienceBuilder", 'abForm', 'loadAudience', { channels: this.state.channels, ...backendOptions, ...updatedState })
        window.location.href = '/build-audience'
      }
      asyncFunc()
    }
    // Handle Cancel
    else {
      this.setState(e => e.isFetchingAudiences = false)
      this.controller.abort()
      this.controller = new AbortController()
    }
  }

  isValidNumber(inputValue, allowDecimal = false) {
    // Regular expression to allow only numbers, and optionally a decimal point
    const regex = allowDecimal ? /^[0-9]+(\.[0-9]{1,2})?$/ : /^[0-9]+$/;

    // Test the input value against the regex and return true if it matches
    return regex.test(inputValue);
  }

  render() {
    if (this.props.isShown) {
      return (
        <MuiThemeProvider theme={defaultTheme}>
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: '100vw', height: '100vh', position: 'fixed', top: 0, left: 0, zIndex: 100,
            backgroundColor: 'rgba(0,0,0,0.2)'
          }}
          >
            {/* GRAY SCREEN BACKGROUND */}
            <div
              style={{ width: '100vw', height: '100vh', position: 'fixed', top: 0, right: 0 }}
              onClick={() => {
                if (!this.state.isFetchingAudiences) {
                  this.props.onChange(false)
                }
              }}
            />
            {/* Error Alert */}
            {this.state.formErrorMessage !== "" && (
              <div style={{ position: 'fixed', top: 10, right: 10, background: "#ffc067", borderRadius: 10, padding: '1%', boxShadow: 'var(--box-shadow-stripe)' }} onClick={() => { this.setState({ formErrorMessage: '' }) }}>
                <p>{this.state.formErrorMessage}</p>
              </div>
            )}
            {/* Main Start Form */}
            <div
              style={{
                zIndex: 101,
                background: 'white',
                maxWidth: 800,
                boxShadow: "var(--box-shadow-stripe)",
                borderRadius: 10,
                padding: '1%'
              }}
            >
              <h2 style={{ fontSize: 30, textAlign: 'center' }}>Create an Audience</h2>
              <div style={{ boxShadow: "var(--box-shadow-stripe)", padding: '1%', borderRadius: 5, marginTop: '1vh' }}>
                <h2>1. Channel Selection</h2>
                <Select native style={{ width: '100%' }} variant="outlined" value={this.state.activeChannel !== null ? this.state.activeChannel.id : null} onChange={(e) => {
                  for (let channel of this.state.channels) {
                    if (channel.id === e.target.value) {
                      // Determin Audience Breakdown
                      let audienceBDown = 0.5
                      if (channel.hasOwnProperty('combined')) {
                        // Propsect Only
                        if (channel.combined.hasProspects && !channel.combined.hasCustomers) {
                          audienceBDown = 0
                        }
                        // Customer Only
                        else if (!channel.combined.hasProspects && channel.combined.hasCustomers) {
                          audienceBDown = 1
                        }
                      }

                      // Update State
                      this.setState({ 
                        activeChannel: channel, 
                        audienceRatio: audienceBDown, 
                        thresholdSelection: "noThreshold",
                        targetSpend: "",
                        targetQuanity: ""
                      })
                      return
                    }
                  }
                }}>
                  {this.state.activeChannel === null ? (
                    <option value={null}></option>
                  ) : null}
                  {this.state.channels.map((obj) => {
                    return (
                      <option value={obj.id}>{obj.program}</option>
                    )
                  })}
                </Select>
              </div>
              <div style={{ boxShadow: "var(--box-shadow-stripe)", padding: '1%', borderRadius: 5, marginTop: '1vh' }}>
                <h2>2. Threshold Selection</h2>
                <ButtonBase color="primary" style={{ width: '100%' }}>
                  <Button variant='outlined' onClick={() => { this.setState({ thresholdSelection: "noThreshold" }) }} color={this.state.thresholdSelection === "noThreshold" ? "primary" : "default"} style={{ width: '100%' }}>No Threshold</Button>
                  <Button variant='outlined' disabled={this.state.activeChannel && !this.state.activeChannel.thresholdSelection.spend} onClick={() => { this.setState({ thresholdSelection: "spend" }) }} color={this.state.thresholdSelection === "spend" ? "primary" : "default"} style={{ width: '100%', marginLeft: 5 }}>Spend</Button>
                  <Button variant='outlined' disabled={this.state.activeChannel && !this.state.activeChannel.thresholdSelection.quantity} onClick={() => { this.setState({ thresholdSelection: "quantity" }) }} color={this.state.thresholdSelection === "quantity" ? "primary" : "default"} style={{ width: '100%', marginLeft: 5, marginRight: 5 }}>Quantity</Button>
                </ButtonBase>
              </div>
              <div style={{ backgroundColor: this.state.thresholdSelection === "noThreshold" ? "rgba(0,0,0,0.2)" : "transparent", borderRadius: 5 }}>
                <div style={{ boxShadow: "var(--box-shadow-stripe)", padding: '1%', borderRadius: 5, marginTop: '1vh' }}>
                  <h2>3. Threshold Type</h2>
                  <ButtonBase color="primary" style={{ width: '100%' }}>
                    <Button variant='outlined'
                      disabled={this.state.thresholdSelection === "noThreshold"}
                      onClick={() => { this.setState({ isWholeOrLocation: true }) }} color={this.state.isWholeOrLocation ? "primary" : "default"} style={{ width: '100%', marginLeft: 5, marginRight: 5 }}>Whole Audience</Button>
                    <Button variant='outlined'
                      disabled={this.state.thresholdSelection === "noThreshold"}
                      onClick={() => { this.setState({ isWholeOrLocation: false }) }} color={!this.state.isWholeOrLocation ? "primary" : "default"} style={{ width: '100%', marginLeft: 5, marginRight: 5 }}>Location</Button>
                  </ButtonBase>
                </div>
                <div style={{ boxShadow: "var(--box-shadow-stripe)", padding: '1%', borderRadius: 5, marginTop: '1vh' }}>
                  <h2>4. Threshold Settings</h2>
                  {this.state.thresholdSelection === "spend" ? (
                    <React.Fragment>
                      <Input
                        color="primary"
                        placeholder={`Spend ${this.state.isWholeOrLocation ? "Across Locations" : "by Location"}`}
                        style={{ width: '100%' }}
                        disabled={this.state.thresholdSelection === "noThreshold"}
                        startAdornment={<InputAdornment style={{ paddingRight: 5 }}>$</InputAdornment>}
                        type='number'
                        value={this.state.targetSpend}
                        onChange={(e) => {
                          if (this.isValidNumber(e.target.value, true) || e.target.value === "") {
                            this.setState({ targetSpend: e.target.value })
                          }
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <Input color="primary"
                        placeholder={`Quantity ${this.state.isWholeOrLocation ? "Across Locations" : "by Location"}`}
                        type='number'
                        disabled={this.state.thresholdSelection === "noThreshold"}
                        style={{ width: '100%' }}
                        value={this.state.targetQuanity}
                        onChange={(e) => {
                          if (this.isValidNumber(e.target.value, false) || e.target.value === "") {
                            this.setState({ targetQuanity: e.target.value })
                          }
                        }}
                      />
                    </React.Fragment>
                  )}
                </div>
                <div style={{ boxShadow: "var(--box-shadow-stripe)", padding: '1%', borderRadius: 5, marginTop: '1vh' }}>
                  <h2>5. Audience Makeup</h2>
                  <p>Simple</p>
                  <div style={{ display: 'flex' }}>
                    <Button variant={"outlined"} disabled={evaluateAudienceButtonDisabled(this.state.activeChannel) || this.state.isGiveMeTheBest || this.state.thresholdSelection === "noThreshold"} style={{ marginRight: 5, width: '33.3%' }} fullWidth onClick={() => { this.setState({ audienceRatio: (0) }) }}>All Prospects</Button>
                    <Button variant={"outlined"} disabled={evaluateAudienceButtonDisabled(this.state.activeChannel) || this.state.thresholdSelection === "noThreshold"} color={this.state.isGiveMeTheBest ? "primary" : "default"} style={{ width: '33.3%', marginRight: 5 }} fullWidth onClick={() => { this.setState({ audienceRatio: (0.5), isGiveMeTheBest: !this.state.isGiveMeTheBest }) }}>Give me the best</Button>
                    <Button variant={"outlined"} disabled={evaluateAudienceButtonDisabled(this.state.activeChannel) || this.state.isGiveMeTheBest || this.state.thresholdSelection === "noThreshold"} style={{ width: '33.3%' }} fullWidth onClick={() => { this.setState({ audienceRatio: (1) }) }}>All Customers</Button>
                  </div>
                  <p style={{ marginTop: 5 }}>Detailed</p>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                  }}>
                    <AudienceSlider disabled={
                      evaluateAudienceButtonDisabled(this.state.activeChannel) ||
                      this.state.isGiveMeTheBest ||
                      this.state.thresholdSelection === "noThreshold"
                    } activeStep={this.state.audienceRatio * 100} onChange={(e) => { this.setState({ audienceRatio: (e / 100) }) }} />
                  </div>
                  {this.state.audienceRatio !== 1 ? (
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Minimum Prospects"
                      type="number"
                      disabled={this.state.thresholdSelection === "noThreshold"}
                      value={this.state.minProspects}
                      onChange={(e) => {
                        if (this.isValidNumber(e.target.value, false) || e.target.value === "") {
                          this.setState({ minProspects: e.target.value })
                        }
                      }} />
                  ) : (null)}
                </div>
              </div>
              {this.state.isFetchingAudiences && (
                <LoadingBanner />
              )}
              <Button onClick={() => { this.handleSubmit() }} style={{ textAlign: 'center', width: '100%', marginTop: 10, backgroundColor: '#515151' }} variant="outlined" color="primary">{this.state.isFetchingAudiences ? "Fetching Counts Please Wait" : "Go to Filter Criteria"}</Button>
            </div>
          </div>
        </MuiThemeProvider>
      )
    }
    return null

  }
}



// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/startForm/startForm.jsx